import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import Avatar1 from '@public/images/contactUs/brandAvatar1.png';
import Avatar2 from '@public/images/contactUs/brandAvatar2.png';
import Avatar3 from '@public/images/contactUs/brandAvatar3.png';
import UserReviewsIcon from '@public/images/home/userReviews-icon.png';

import ArrowRB from '@/components/Icon/ArrowR_B';
import Email from '@/components/Icon/Email';
import Title from '@/components/Title';

const Collaboration = () => {
  const { t } = useTranslation('contactUs');
  const brandList = [
    {
      title: t('品牌合作'),
      description: t('品牌合作详情'),
      avatar: {
        img: Avatar1,
        name: t('品牌合作人'),
      },
      email: t('品牌邮箱'),
    },
    {
      title: t('PR合作'),
      description: t('PR详情'),
      avatar: {
        img: Avatar2,
        name: t('PR合作人'),
      },
      email: t('PR邮箱'),
    },
    {
      title: t('商务合作'),
      description: t('商务详情'),
      avatar: {
        img: Avatar3,
        name: t('商务联系人'),
      },
      email: t('商务邮箱'),
    },
  ];
  return (
    <div className="flex flex-col items-center bg-[url('/images/home/blog-bg.png')] bg-[length:315px_auto] bg-[center_0px] bg-no-repeat lg:bg-[length:676px_auto] lg:pt-[90px] xl:bg-[length:800px_auto] xl:pt-[60px]">
      <Title theme="colorful" className="relative">
        <span dangerouslySetInnerHTML={{ __html: t('与悟空合作') }} />
        <Image
          src={UserReviewsIcon}
          width={128}
          alt=""
          className="absolute -right-[128px] -top-[53px] hidden lg:block"
        />
      </Title>
      <div className="mt-6 flex flex-col space-y-5 lg:mt-12 lg:flex-row lg:space-x-6 lg:space-y-0  xl:mt-15 ">
        {brandList.map((item) => (
          <div
            key={item.title}
            className="flex flex-1 flex-col rounded-[24px] border-2 border-white bg-gradient-to-b from-white/40 to-white/90 px-5 py-5 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] backdrop-blur lg:py-6 lg:text-2xl lg:leading-[30px] xl:rounded-5xl xl:px-6 xl:py-8"
            style={{
              background:
                'linear-gradient(184deg, rgba(255, 83, 83, 0.03) 11.74%, rgba(109, 56, 251, 0.03) 60.79%, rgba(0, 157, 255, 0.03) 90.39%), linear-gradient(180deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.90) 100%)',
            }}
          >
            <div
              style={{
                background: 'linear-gradient(90deg, #FF5353 14.29%, #6D38FB 63.38%, #009DFF 99.65%)',
              }}
              className="mb-4 flex h-7 w-7 items-center justify-center rounded-full lg:mb-5 lg:h-8 lg:w-8 xl:mb-6"
            >
              <ArrowRB />
            </div>
            <h2 className="text-2xl font-bold leading-6 text-[#1B1F4D] lg:text-[24px] lg:leading-[29px]  xl:text-[28px] xl:leading-[34px]">
              {item.title}
            </h2>
            <p className="mt-2 text-[16px] leading-[1.2] text-wk-words-2 xl:text-[20px]">{item.description}</p>
            <div className="mt-4 flex items-center space-x-3 text-[16px] text-wk-words-2 xl:mt-6 xl:space-x-4 xl:text-[20px]">
              <Image
                src={item.avatar.img}
                alt={item.avatar.name}
                width={32}
                height={32}
                className="lg:h-10 lg:w-10 xl:h-12 xl:w-12"
              />
              <p>{item.avatar.name}</p>
            </div>
            <div className="mt-3 flex items-center space-x-3 xl:mt-4 xl:space-x-4">
              <div
                style={{
                  background:
                    'linear-gradient(94deg, rgba(156, 65, 199, 0.06) 0.44%, rgba(63, 100, 253, 0.06) 44.33%, rgba(2, 156, 255, 0.06) 97%)',
                }}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-wk-words-2 lg:h-9 lg:w-9 xl:h-10 xl:w-10"
              >
                <Email className="w-5" />
              </div>
              <p className="break-all text-[16px] leading-[1.2] text-wk-words-2 xl:text-[20px]">{item.email}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Collaboration;
